/**
 * Tab composition for the financial-analysis view's destinations (MOR-1280).
 *
 * The one financial-analysis task backs two Investigations destinations:
 * Historical Financial Analysis (the worksheets — what a report normally
 * contains) and Solvency Analysis (the indicator assessment, now its landing
 * view instead of a tab that was easy to lose track of). No other route
 * renders the view: the Data section does not list this agent.
 */

import type { FinancialAnalysisSection } from "./types";

export type FinancialAnalysisTab = "worksheets" | "indicators" | "feed";

export const FINANCIAL_SECTION_TITLES: Record<
  FinancialAnalysisSection,
  string
> = {
  historical: "Historical Financial Analysis",
  solvency: "Solvency Analysis",
};

/** Tabs shown for a destination, in display order. */
export function tabsForSection(
  section: FinancialAnalysisSection,
): ReadonlyArray<FinancialAnalysisTab> {
  return section === "historical"
    ? ["worksheets", "feed"]
    : ["indicators", "feed"];
}

/**
 * Tab a destination opens on. A running task opens the agent feed, as
 * before; otherwise the destination's own content leads.
 */
export function defaultTabForSection(
  section: FinancialAnalysisSection,
  isRunning: boolean,
): FinancialAnalysisTab {
  if (isRunning) return "feed";
  return section === "historical" ? "worksheets" : "indicators";
}

/** Display title for a financial-analysis section. */
export function titleForSection(section: FinancialAnalysisSection): string {
  return FINANCIAL_SECTION_TITLES[section];
}
